import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

export default function TeamsTab({ teamOptions, setTeamOptions }) {
  return (
    <div className="space-y-6">
      <div>
        <p className="text-sm text-gray-600 mb-4">
          Configure teams that participants can choose from during registration.
        </p>
        
        {/* Existing Teams */}
        <div className="space-y-3">
          {teamOptions.map((team, index) => (
            <div 
              key={team.id}
              className={`p-4 rounded-lg border ${team.enabled ? 'bg-white' : 'bg-gray-50 opacity-60'}`}
            >
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={team.enabled}
                    onChange={() => {
                      const updated = [...teamOptions];
                      updated[index] = { ...updated[index], enabled: !team.enabled };
                      setTeamOptions(updated);
                    }}
                    className="w-4 h-4 text-green-600 rounded"
                  />
                  <span className="text-sm font-medium text-gray-700">Enabled</span>
                </label>
                
                <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Team ID</label>
                    <input
                      type="text"
                      value={team.id}
                      disabled
                      className="w-full px-3 py-2 text-sm border rounded-lg bg-gray-100 text-gray-900"
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Display Name</label>
                    <input
                      type="text"
                      value={team.name}
                      onChange={e => {
                        const updated = [...teamOptions];
                        updated[index] = { ...updated[index], name: e.target.value };
                        setTeamOptions(updated);
                      }}
                      className="w-full px-3 py-2 text-sm border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
                      data-testid={`team-name-${team.id}`}
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Color</label>
                    <div className="flex items-center gap-2">
                      <input
                        type="color"
                        value={team.color}
                        onChange={e => {
                          const updated = [...teamOptions];
                          updated[index] = { ...updated[index], color: e.target.value };
                          setTeamOptions(updated);
                        }}
                        className="w-10 h-10 rounded-lg cursor-pointer border"
                        data-testid={`team-color-picker-${team.id}`}
                      />
                      <input
                        type="text"
                        value={team.color}
                        onChange={e => {
                          const updated = [...teamOptions];
                          updated[index] = { ...updated[index], color: e.target.value };
                          setTeamOptions(updated);
                        }}
                        className="flex-1 px-3 py-2 text-sm border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
                        data-testid={`team-color-hex-${team.id}`}
                      />
                    </div>
                  </div>
                </div>
                
                <button
                  onClick={() => {
                    const updated = teamOptions.filter((_, i) => i !== index);
                    setTeamOptions(updated);
                  }}
                  className="p-2 text-red-500 hover:bg-red-50 rounded-lg"
                  title="Remove team"
                  data-testid={`team-delete-${team.id}`}
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
        
        {/* Add New Team */}
        <div className="mt-4 pt-4 border-t">
          <Button
            variant="outline"
            onClick={() => {
              const newId = `team_${Date.now()}`;
              setTeamOptions([
                ...teamOptions,
                { id: newId, name: 'New Team', color: '#6b7280', enabled: true }
              ]);
            }}
            className="gap-2"
            data-testid="add-team-btn"
          >
            <Plus className="w-4 h-4" />
            Add Team
          </Button>
        </div>
      </div>
      
      {/* Preview */}
      <div className="bg-gray-50 rounded-xl p-4">
        <p className="text-sm font-medium text-gray-700 mb-3">Team Preview</p>
        <div className="flex flex-wrap gap-2">
          {teamOptions.filter(t => t.enabled).map(team => (
            <span
              key={team.id}
              className="px-3 py-1 text-sm font-medium text-white rounded-full"
              style={{ backgroundColor: team.color }}
            >
              {team.name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
